import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedHTMLMessage, FormattedMessage } from '../../../components/I18n';
import { useFullTrack } from '../../tracks';
import ExamFinishedScreenLayout from './ExamFinishedScreenLayout';

const ExamIncompleteExercisesScreen = ({
  trackId
}) => {
  const {
    track,
    trackLoading,
    trackError
  } = useFullTrack(trackId);
  return /*#__PURE__*/_jsx(ExamFinishedScreenLayout, {
    error: trackError,
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.practicalsIncomplete"
    }),
    illustration: "announcement",
    loading: trackLoading,
    showSecondaryRetakeCTA: true,
    subheading: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "learningCenter.exams.finished.practicalsIncompleteSubheading",
      options: {
        courseName: track && track.name
      }
    }),
    trackId: trackId
  });
};

export default ExamIncompleteExercisesScreen;